/**
 * @generated SignedSource<<5411d3e5cfc1cc3be38ee2233853dae6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DropdownMenus_UJPageMenu_ujs$data = ReadonlyArray<{
  readonly customer: {
    readonly customerID: number;
  };
  readonly isSelfService: boolean;
  readonly ujID: number;
  readonly " $fragmentType": "DropdownMenus_UJPageMenu_ujs";
}>;
export type DropdownMenus_UJPageMenu_ujs$key = ReadonlyArray<{
  readonly " $data"?: DropdownMenus_UJPageMenu_ujs$data;
  readonly " $fragmentSpreads": FragmentRefs<"DropdownMenus_UJPageMenu_ujs">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "DropdownMenus_UJPageMenu_ujs",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "ujID",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Customer",
      "kind": "LinkedField",
      "name": "customer",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customerID",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isSelfService",
      "storageKey": null
    }
  ],
  "type": "UserJourney",
  "abstractKey": null
};

(node as any).hash = "4a9423ae3e4e703f4052a7379ad83215";

export default node;
